"use client";

import * as React from "react";

import { cn } from "@/src/lib/utils/cn";

type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, ...props }, ref) => {
    return (
      <input
        ref={ref}
        className={cn(
          "w-full min-h-[3.25rem] rounded-xl border border-[#e5e7eb] bg-white px-4 py-3 text-[var(--color-ink)] [transition:border-color_220ms_ease,box-shadow_220ms_ease,background-color_220ms_ease] outline-none placeholder:text-[var(--color-ink-muted)] focus:border-[var(--color-accent)] focus:bg-white focus:shadow-[0_0_0_3px_rgba(238,55,106,0.12)] aria-[invalid=true]:border-[rgba(182,67,44,0.4)] aria-[invalid=true]:shadow-[0_0_0_4px_rgba(182,67,44,0.08)] disabled:cursor-not-allowed disabled:opacity-60 [&::-webkit-contacts-auto-fill-button]:hidden [&::-webkit-credentials-auto-fill-button]:hidden [&::-webkit-textfield-decoration-container]:hidden [&::-webkit-contacts-auto-fill-button]:pointer-events-none [&::-webkit-credentials-auto-fill-button]:pointer-events-none [&::-webkit-textfield-decoration-container]:pointer-events-none [appearance:none] [&[type=email]]:[appearance:none] [&[type=tel]]:[appearance:none] [&[type=email]]:bg-none [&[type=tel]]:bg-none",
          className,
        )}
        {...props}
      />
    );
  }
);

Input.displayName = "Input";
